import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from "@angular/core";
import {PlanningPanelModel} from "../../../models/planning-panel.model";
import {PlanningViewSettingsResourcesModel} from "../../../models/planning-view-settings.model";
import {PlanningDragAndDropService} from "../../services/planning-drag-and-drop.service";
import {CdkDragDrop, CdkDragEnter, moveItemInArray, transferArrayItem} from "@angular/cdk/drag-drop";
import * as _ from "lodash";
import {ResourceSegmentModel} from "../../../models/resource-segment.model";
import {PlanningRouteModel} from "../../../models/planning-route.model";

require('./planning-draft-resource-panel-view.scss');
@Component({
  standalone: false,
  selector: 'app-planning-draft-resource-panel-view',
  templateUrl: './planning-draft-resource-panel-view.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftResourcePanelViewComponent implements OnChanges {

  @Input() resource: any;
  @Input() resources: ResourceSegmentModel[];
  @Input() routes: PlanningRouteModel[];
  @Input() visibleRouteIds: string[];
  @Input() settings: PlanningViewSettingsResourcesModel;
  @Input() routesSettings: any;
  @Input() draft: any;
  @Input() panels: PlanningPanelModel[];
  @Input() panel: PlanningPanelModel;
  @Input() itemElementSize?: string;
  @Input() selectedJobIds: string[];
  @Input() jobs: any[];

  @Output() onClose = new EventEmitter<void>();
  @Output() onOpenRoute = new EventEmitter<any>();
  @Output() onEditResourceAllocation = new EventEmitter<{ route: any, event: any }>();
  @Output() onChangeRouteResource = new EventEmitter<{ routeId: string, event: any }>();
  @Output() onLockRouteChange = new EventEmitter<{ id: string, locked: boolean }>();
  @Output() onVisibleRoutesChange = new EventEmitter<string[]>();
  @Output() onDispatchRoutes = new EventEmitter<string[]>();
  @Output() onReoptimize = new EventEmitter<string>();
  @Output() onPrint = new EventEmitter<string>();
  @Output() onPrintLoadingSheet = new EventEmitter<string>();
  @Output() onChangeResourceSequence = new EventEmitter<{ orderedRouteIds: string[], routeGroupId: string[] }>();
  @Output() onDelete = new EventEmitter<string>();
  @Output() onDispatch = new EventEmitter<string>();
  @Output() onCreateRoute = new EventEmitter<{ id: string, jobIds: string[], stopIdOrder?: string[], optimize?: boolean, allowSkillsMismatch?: boolean }>();
  @Output() onUpdateRouteResource = new EventEmitter<{ route: any, resourceId: string }>();

  public visibleKeys: { [key: string]: boolean } = {};
  public sortedRoutes: PlanningRouteModel[];
  public hovered: boolean = false;
  public connectedPanelIds: string[];

  constructor(@Inject(PlanningDragAndDropService) private planningDragAndDropService: PlanningDragAndDropService) {}

  // get sortedRoutes() {
  //   if (!this.routes) {
  //     return [];
  //   }
  //   return [...this.routes].sort((a, b) => {
  //     const seqA = a.sequenceInRouteGroup ?? 0;
  //     const seqB = b.sequenceInRouteGroup ?? 0;
  //     return seqA - seqB;
  //   });
  // }

  ngOnChanges(changes: SimpleChanges): void {
    // Initialize visibility when routes change
    if (changes.visibleRouteIds && this.visibleRouteIds) {
      this.visibleKeys = {};
      this.visibleRouteIds?.forEach((id) => {
        this.visibleKeys[id] = true;
      })
    }

    if (changes.panels) {
      const filteredPanels = _.filter(this.panels, (p) => {
        return p.id !== this.panel.id;
      })
      this.connectedPanelIds = _.map(filteredPanels, 'id');
    }

    if (changes.routes) {
      this._setSortedRoutes();
    }

    if (changes.resources) {
      this.connectedPanelIds = this.connectedPanelIds.concat(this.resources.map(resource => resource.id));
    }
  }

  drop(event: CdkDragDrop<any>) {
    this.planningDragAndDropService.onDropResourceRoutes(
      event,
      this.resource,
      this.selectedJobIds,
      (hovered: boolean) => this.hovered = hovered,
      this.jobs
    ).then((result) => {
      if (result) {
        if (result.type === 'sequence') {
          this.onChangeResourceSequence.emit(result.data);
        } else if (result.type === 'update') {
          this.onUpdateRouteResource.emit(result.data);
        } else if (result.type === 'create') {
          this.onCreateRoute.emit(result.data);
        }
      }
    });
  }

  onToggleVisibleRoute(id: string, isVisible: boolean) {
    this.visibleKeys[id] = isVisible;
    const visibleIds = Object.keys(this.visibleKeys).filter(key => this.visibleKeys[key]);
    this.onVisibleRoutesChange.emit(visibleIds);
  }

  trackByRouteId(index: number, route: { id?: string | number }) {
    return route.id ?? index;
  }

  private _setSortedRoutes(): void {
    if (!this.routes) {
      this.sortedRoutes = [];
      return;
    }
    this.sortedRoutes = [...this.routes].sort((a, b) => {
      const seqA = a.sequenceInRouteGroup ?? 0;
      const seqB = b.sequenceInRouteGroup ?? 0;
      return seqA - seqB;
    });
  }

  onEnterEmpty() {
    this.hovered = true;
  }

  onExitEmpty() {
    this.hovered = false;
  }
}
